<template>
  <CompanyWrapper :isOpenEvent="isOpenEvent">
    <Loading v-if="isLoading"></Loading>
    <BadRequest :lang="lang" v-if="isBadRequest"></BadRequest>
    <InternalServerError
      v-if="isCreateServerError"
      :lang="lang"
    ></InternalServerError>
    <main
      v-if="!isLoading && !isBadRequest && !isCreateServerError"
      class="main"
    >
      <!-- パンくずリスト -->
      <ol class="breadcrumb-trail__list">
        <li class="breadcrumb-trail__list--item">
          <router-link
            v-if="isOpenEvent"
            :to="{ path: `/${langPath}` }"
            class="breadcrumb-trail__list--item__link"
          >
            TOP
          </router-link>
          <router-link
            v-else
            :to="{ path: `/${langPath}company/summary` }"
            class="breadcrumb-trail__list--item__link"
          >
            EventList
          </router-link>
        </li>
        <li class="breadcrumb-trail__list--item">
          <router-link
            v-if="isOpenEvent"
            :to="{ path: `/${langPath}result` }"
            class="breadcrumb-trail__list--item__link"
          >
            Results
          </router-link>
          <router-link
            v-else
            :to="{ path: `/${langPath}company/event/${dataEventRanking.code}` }"
            class="breadcrumb-trail__list--item__link"
          >
            Detail
          </router-link>
        </li>
        <li class="breadcrumb-trail__list--item">
          <router-link
            v-if="!isOpenEvent"
            :to="{
              path: `/${langPath}company/ranking`,
              query: {
                event: this.$route.query.event,
                page: this.$route.query.page,
              },
            }"
            class="breadcrumb-trail__list--item__link"
          >
            Result
          </router-link>
          <router-link
            v-else
            :to="{
              path: `/${langPath}company/ranking`,
              query: {
                event: this.$route.query.event,
                page: this.$route.query.page,
              },
            }"
            class="breadcrumb-trail__list--item__link"
          >
            {{ dataEventRanking.name }}
          </router-link>
        </li>
      </ol>
      <!-- タイトル -->
      <section class="main__title">
        <h1
          class="main__title--name"
          :style="`border-left: solid 8px ${dataEventRanking.text.event_color_code};`"
        >
          {{ dataEventRanking.name }}
        </h1>
        <figure class="main__title--figure">
          <img
            :src="`https://tmf-virtualrun.jp/images/company/${dataEventRanking.text.image_file_name}`"
            alt=""
            height="52"
          />
        </figure>
      </section>
      <!-- 説明（Oliveから入稿） -->
      <p
        class="ranking-description"
        v-html="dataEventRanking.text.ranking_description"
      ></p>
      <!-- 概要テーブル -->
      <!-- 社内イベント -->
      <EventInfo
        v-if="eventType === 0"
        :data-event-ranking="dataEventRanking"
        :data-event-summary="dataEventSummary"
      ></EventInfo>
      <!-- 対抗イベント -->
      <TeamEventInfo
        v-if="eventType === 1"
        :data-event-ranking="dataEventRanking"
        :data-event-summary="dataEventSummary"
      ></TeamEventInfo>
      <hr class="width-line" />
      <!-- 社内イベント -->
      <CloseRankingContents
        v-if="eventType === 0"
        :data-event-ranking="dataEventRanking"
        :data-event-summary="dataEventSummary"
        :is-foreign-country="isForeignCountry"
      ></CloseRankingContents>
      <!-- 対抗イベント -->
      <TeamRankingContents
        v-if="eventType === 1"
        :data-event-ranking="dataEventRanking"
        :data-event-summary="dataEventSummary"
        :is-foreign-country="isForeignCountry"
      ></TeamRankingContents>
    </main>
  </CompanyWrapper>
</template>

<script>
import CompanyWrapper from "../../../../components/sp/company/CompanyWrapper";
import Loading from "../../../../components/sp/Loading";
import BadRequest from "../../../../components/common/status/BadRequest";
import InternalServerError from "../../../../components/common/status/InternalServerError";
import EventInfo from "../../../../components/sp/ranking/EventInfo";
import TeamEventInfo from "../../../../components/sp/company/ranking/TeamEventInfo";
import { RepositoryFactory } from "../../../../api/RepositoryFactory";
import cognito from "../../../../plugins/cognito";
import CloseRankingContents from "../../../../components/sp/company/ranking/CloseRankingContents";
import TeamRankingContents from "../../../../components/sp/company/ranking/TeamRankingContents";

export default {
  data() {
    return {
      isLoading: true,
      isBadRequest: false,
      isCreateServerError: false,
      isForeignCountry: false,
      isOpenEvent: false,
      dataEventRanking: null,
      dataEventSummary: null,
      eventType: 0,
      nassEventId: "",
    };
  },
  async created() {
    // イベントIDをsessionストレージに入れる
    sessionStorage.setItem("nassEventId", this.$route.query.event);
    // イベントサマリ情報取得
    const EventRepository = RepositoryFactory.get("event");
    const isCompany = this.$route.path.includes("company");
    const params = {
      event: sessionStorage.getItem("nassEventId"),
      lang: this.lang,
      is_company_event: isCompany || "",
      company_user_name: cognito.getUserName() || "",
    };
    try {
      const response = await EventRepository.getEventRanking(params);
      this.dataEventRanking = response.data;
      this.isForeignCountry = response.data.text.new_event_api_flag;
      this.isOpenEvent = response.data.text.open_event_flag;
      // イベント種別取得(0：社内イベント 1：対抗イベント)
      this.eventType = response.data.text.event_type;
      this.nassEventId = sessionStorage.getItem("nassEventId");
      const rankingItem = response.data.ranking_item;
      // イベントインフォ取得
      await this.fetchEventSummary(rankingItem);
    } catch (e) {
      if (e.response.status === 400) {
        this.isBadRequest = true;
        return;
      }
      this.isCreateServerError = true;
    } finally {
      this.isLoading = false;
    }
  },
  methods: {
    /**
     * イベントサマリ取得
     */
    fetchEventSummary: async function (rankingItem) {
      const params = {
        event: sessionStorage.getItem("nassEventId"),
        lang: this.lang,
        ranking_item: rankingItem || "",
      };
      const EventRepository = RepositoryFactory.get("event");
      const response = await EventRepository.getEventSummary(params);
      this.dataEventSummary = response.data;
    },
  },
  computed: {
    lang: function () {
      return this.$store.state.lang;
    },
    langPath: function () {
      return this.$store.state.langPath;
    },
  },
  components: {
    CompanyWrapper,
    Loading,
    BadRequest,
    InternalServerError,
    EventInfo,
    TeamEventInfo,
    CloseRankingContents,
    TeamRankingContents,
  },
  name: "Ranking",
};
</script>

<style scoped>
.main {
  &__title {
    margin: 40px 0 0 0;
    display: flex;
    align-items: center;

    &--name {
      line-height: 1.25;
      padding: 0 0 0 15px;
      border-left: solid 8px var(--blueFoundationColor);
      font-size: 24px;
      font-weight: 900;
    }

    &--figure {
      padding: 9px;
      border: solid 1px var(--defaultGrayColor);
    }
  }

  .ranking-description {
    margin: 42px 0 0 0;
    line-height: 1.7;
    font-size: 14px;
    font-weight: 500;
  }

  .width-line {
    margin: 40px 0 0 0;
    width: 100%;
    border-top: solid 1px #000;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/sp/company/ranking/Ranking.vue